/**
 * @generated SignedSource<<dbc4dd01a2ae7fd90a253094cdfe9e7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PullRequestPickerPullRequest$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly isDraft: boolean;
  readonly number: number;
  readonly repository: {
    readonly id: string;
    readonly name: string;
    readonly nameWithOwner: string;
    readonly owner: {
      readonly __typename: string;
      readonly login: string;
    };
  };
  readonly state: PullRequestState;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "PullRequestPickerPullRequest";
};
export type PullRequestPickerPullRequest$key = {
  readonly " $data"?: PullRequestPickerPullRequest$data;
  readonly " $fragmentSpreads": FragmentRefs<"PullRequestPickerPullRequest">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PullRequestPickerPullRequest"
};

(node as any).hash = "1ed963c0c87aa8a0457f222ecd0c2db0";

export default node;
